import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { OurTeamComponent } from './our-team/our-team.component';
import { MatTooltipModule } from "@angular/material/tooltip";

const routes: Routes = [
  { path: '', component: OurTeamComponent },
]

@NgModule({
  declarations: [OurTeamComponent],
  imports: [
    CommonModule,
    MatTooltipModule,
    RouterModule.forChild(routes)
  ]
})
export class TeamModule { }
